<template>
  <div class="component-user-info">
    <div v-if="certType === 'IDCARD'" class="page-rnr-main-card pb-36">
      <div class="component-ocr-idcard-icon-reader" />
      <van-row type="flex">
        <van-col v-if="showBluetooth" :span="24" class="van-hairline--right">
          <!-- <div class="step-title">方式一</div> -->
          <Bluetooth @change="handleDeviceRead" />
        </van-col>
        <!-- <van-col :span="showBluetooth ? 12 : 24">
          <div class="step-title">{{ showBluetooth ? '方式二' : '' }}</div>
          <OcrIdcard :images="certPic" :empty="showBluetooth ? 'normal' : 'small'" :customer="customer" @change="handleDeviceRead" />
        </van-col> -->
      </van-row>
    </div>
    <div class="page-rnr-main-card pd-32" v-if="refrash">
      <FromRender
        ref="formRenderRef"
        v-model="formData"
        :schema="SCHEMA"
        @change="handleFormDataChange"
      >
        <template #long-term>
          <van-checkbox
            v-model="formData.longTerm"
            class="long-term"
            @change="handleLongTermChange"
          >
            长期有效
          </van-checkbox>
        </template>

        <template #number-format>
          <div style="color:darkgreen; background-color: gainsboro;">{{ certFormat }}</div>
        </template>
      </FromRender>
    </div>
  </div>
</template>

<script>
import cache from '@/utils/cache'
import dayjs from 'dayjs'
import FromRender from '@/components/FormRender'
import OcrIdcard from '@/components/Ocr/Idcard'
import Bluetooth from '@/components/Bluetooth'
import { isInApp } from '@/utils/bridge'

export default {
  name: 'UserInfo',
  components: { OcrIdcard, Bluetooth, FromRender },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    certType: {
      type: String,
      default: ''
    },
    customer: {
      type: Boolean,
      default: false
    },
    showPhone: {
      type: Boolean,
      default: false
    },
    certFormat: {
      type: String,
      default: '号码格式：110102YYYYMMDD888X'
    }
  },
  data() {
    const { SEX_OPTIONS, CARD_TYPE } = this.$store.getters.dict
    return {
      refrash: true,
      cardType: CARD_TYPE,
      SCHEMA: Object.assign({
        fullName: {
          type: 'rnr-input',
          label: '姓名',
          rules: [
            { required: true }
          ]
        },
        gender: {
          type: 'rnr-picker',
          label: '性别',
          rules: [
            { required: true }
          ],
          options: SEX_OPTIONS
        },
        certNumber: {
          type: 'rnr-input',
          label: '证件号码',
          rules: [
            { required: true },
            {
              validator: (value) => {
                // 校验结果
                let result = true
                // 判断证件类型
                switch (this.certType) {
                  case 'IDCARD':
                    result = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(value)
                    break
                  case 'HKIDCARD':
                    result = /^[H|M][0-9]{10}$/.test(value)
                    break
                  case 'TAIBAOZHENG':
                    result = /^([0-9]|[a-z]|[A-Z]){10}$/.test(value)
                    break
                  default:
                    break
                }
                return result
              }
            }
          ]
        },
        numberFormat: {
          type: 'slot',
          default: false,
          border: 'none',
          slot: 'number-format'
        },
        certAddress: {
          type: 'rnr-input',
          label: '证件地址',
          rules: [
            {
              required: true,
              validator: (value) => {
                // 校验结果
                var result = true
                if (value.length < 8) {
                  return { result: 0, message: '证件地址填写长度不足！' }
                }
                // 判断证件类型
                switch (this.certType) {
                  case 'IDCARD':
                    // 省、市、区、县、盟、旗、州、镇
                    if (!(value.indexOf('省') > 0 || value.indexOf('市') > 0 || value.indexOf('区') > 0 || value.indexOf('县') > 0 || value.indexOf('盟') > 0 || value.indexOf('旗') > 0 || value.indexOf('州') > 0 || value.indexOf('镇') > 0)) {
                      return { result: 0, message: '请填写完整地址，如“省市区县“等描述!' }
                    }
                    break
                  default:
                    break
                }
                return result
              },
              trigger: 'blur'
            }
          ]
        },
        certExpirationDate: {
          type: 'rnr-date-picker',
          label: '证件有效期',
          minDate: new Date(),
          rules: [
            { required: true }
          ]
        },
        longTerm: {
          type: 'slot',
          default: false,
          border: 'none',
          slot: 'long-term'
        },
        contactAddress: {
          type: 'rnr-input',
          label: '通讯地址',
          rules: [
            {
              required: false,
              validator: (value) => {
                // 校验结果
                var result = true
                if (value === '') return true
                if (value.length < 8) {
                  return { result: 0, message: '请填写正确通讯地址！' }
                }
                return result
              },
              trigger: 'blur'
            }
          ]
        }
      }, this.showPhone ? {
        phone: {
          type: 'rnr-input',
          label: '手机号',
          rules: [
            { required: true },
            { test: /^1\d{10}$/ }
          ]
        }
      } : {}),
      formData: {
        longTerm: false,
        fullName: '',
        gender: 1,
        certNumber: '',
        certAddress: '',
        certExpirationDate: ''
      },
      isInApp,
      certPic: []
    }
  },
  computed: {
    /**
     * 是否展示蓝牙按钮
     */
    showBluetooth() {
      return !this.customer && isInApp
    },
    tipInfo() {
      return this.cardType.filter(el => {
        return el.value === this.certType
      })[0].exemplo
    }
  },
  watch: {
    /**
     * 监听输入值的变动，如果有变动，则重新赋值
     */
    value: {
      handler() {
        Object.keys(this.value).forEach(key => {
          this.formData[key] = this.value[key]
          // 如果当前是长期
          if (key === 'certExpirationDate') {
            this.formData.longTerm = this.value[key] === '长期'
          }
        })
      },
      deep: true
    }
  },
  activated() {
    // 上个页面传过来的证件照片
    const { certPicKey } = this._routerRoot._route.query
    // 证件照片
    const certPic = cache.get(certPicKey)
    // 每次进入页面都查找一次最新的证件照片
    this.certPic = certPic ? certPic.map(item => item.content.slice(item.content.indexOf('base64,') + 7)) : []
  },
  methods: {
    /**
     * 当选择了长期或者非长期之后
     */
    handleLongTermChange() {
      console.log(1)
      if (this.formData.longTerm) {
        console.log(2)
        // this.$set(this.formData, 'certExpirationDate', '长期')
        this.$refs.formRenderRef.handleComponentInput('certExpirationDate', '长期')
        this.$refs.formRenderRef.clearValidate('certExpirationDate')
        // this.refrash = false
        // this.refrash = true
        console.log(3)
      } else {
        console.log(4)
        if (this.formData.certExpirationDate === '长期') {
          console.log(5)
          // this.$set(this.formData, 'certExpirationDate', '')
          this.$refs.formRenderRef.handleComponentInput('certExpirationDate', '')
          this.$refs.formRenderRef.validateByKey('certExpirationDate')
        }
      }
      // this.refrash = false
      // this.refrash = true
      console.log(6)
      this.$emit('formFill', this.formData)
    },

    /**
     * 表单数据发生变化，且当前不为长期
     */
    handleFormDataChange(val, key) {
      // 如果当前
      console.log(7)
      if (key === 'certExpirationDate' && this.formData.certExpirationDate !== '长期') {
        console.log(8, this.formData.certExpirationDate)
        this.$set(this.formData, 'longTerm', false)
        console.log(9)
      }
      console.log(10)
      this.$emit('formFill', this.formData)
      console.log(11)
    },

    /**
     * 校验输入项
     */
    validate() {
      // 校验第一个输入表单
      this.$refs.formRenderRef.validate()
      // 当前过期时间
      const certExpirationDate = dayjs(this.formData.certExpirationDate)
      // 校验成功
      return {
        ...this.formData,
        certExpirationDate: certExpirationDate.isValid() ? certExpirationDate.format('YYYY-MM-DD') : this.formData.certExpirationDate
      }
    },

    /**
     * ocr识别的内容
     */
    handleDeviceRead(info) {
      // 将ocr内容赋值给组件
      this.formData = {
        ...this.formData,
        ...info
      }
      // 当前是否长期
      this.formData.longTerm = info.certExpirationDate === '长期'
      // 校验表单数据
      this.$nextTick(this.$refs.formRenderRef.validate)
      this.$emit('formFill', this.formData)
    }
  }
}
</script>

<style lang="scss">
.component-user-info {
  .page-rnr-main-card {
    .component-ocr-idcard-icon-reader {
      background-image: url(../assets/rnr/ico_idcard_reader.png);
      background-size: auto 100%;
      background-position: center center;
      width: 100%;
      height: 272px;
      margin: 0 auto 24px;
    }
    .van-row {
      align-items: stretch;
      .van-col {
        display: flex;
        flex-direction: column;
        .step-title {
          color: rgba(36, 36, 36, 0.4);
          font-size: 24px;
          font-weight: 500;
          flex-shrink: 0;
          line-height: 32px;
          height: 32px;
          margin: 0 12px;
          text-align: center;
        }
      }
    }
    .long-term {
      margin-top: 12px;
    }
    &.pb-36 {
      padding: 42px 0 36px 0 !important;
    }
    &.pd-32 {
      padding: 0 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserInfo.vue